// NELUM — menu data (prices in IDR '000s)
// Top-level: Food · Beverages · Wine
export const MENU_GROUPS = [
  {
    id: "food",
    label: "Food",
    tagline: "Kitchen · From the island, slowly.",
    sections: [
      {
        id: "hoppers",
        title: "Hoppers & Roti",
        subtitle: "Coastal breakfasts, brought to dinner.",
        items: [
          { name: "Egg Hopper", desc: "Fermented rice-coconut bowl, cage-free yolk, seeni sambol.", price: "78" },
          { name: "String Hoppers", desc: "Steamed rice-flour lace, dhal curry, pol sambol, kiri hodi.", price: "92" },
          { name: "Godamba Roti", desc: "Handkerchief-thin roti, curry leaf butter, coconut jaggery.", price: "68" },
          { name: "Kottu Roti · Chicken", desc: "Chopped roti, curry, egg, chilli, spring onion, black pepper.", price: "128" },
          { name: "Kottu Roti · Prawn", desc: "Tiger prawns, tamarind, curry leaf, roasted chilli.", price: "148" },
        ],
      },
      {
        id: "rice-curry",
        title: "Rice & Curry",
        subtitle: "Seven accompaniments. One island, in a single sitting.",
        items: [
          { name: "Chef's Rice & Curry", desc: "Red country rice, dhal, beetroot curry, ash plantain, pol sambol, papadam, kiri hodi.", price: "168" },
          { name: "Jaffna Crab Curry", desc: "Blue swimmer crab, roasted chilli, gingelly oil, jaffna curry powder.", price: "285" },
          { name: "Negombo Fish Ambulthiyal", desc: "Line-caught tuna, goraka, black pepper, wood-fired clay pot.", price: "175" },
          { name: "Ceylon Beef Curry", desc: "Slow-braised short rib, cinnamon, cardamom, palm sugar.", price: "195" },
          { name: "Cashew & Green Pea", desc: "Toasted cashews, garden peas, coconut milk, pandan.", price: "115" },
        ],
      },
      {
        id: "short-eats",
        title: "Short Eats",
        subtitle: "The bakery tray, elevated.",
        items: [
          { name: "Isso Vadai", desc: "Lentil fritter, tiger prawn, curry leaf, tamarind chutney.", price: "62" },
          { name: "Fish Cutlets", desc: "Seer fish, potato, green chilli, breadcrumb — mustard aioli.", price: "58" },
          { name: "Chicken Rolls", desc: "Cinnamon-spiced chicken, spring roll wrapper, katta sambol.", price: "56" },
          { name: "Deviled Prawns", desc: "Tomato, capsicum, onion, dark soya, roasted chilli.", price: "135" },
        ],
      },
      {
        id: "desserts",
        title: "Desserts",
        subtitle: "Palm sugar, coconut, spice.",
        items: [
          { name: "Watalappan", desc: "Coconut-jaggery custard, cardamom, cashew brittle.", price: "68" },
          { name: "Curd & Kithul", desc: "Buffalo curd, kithul palm treacle, toasted rice.", price: "58" },
          { name: "Ceylon Cinnamon Tres Leches", desc: "Milk-soaked sponge, cinnamon caramel, dark rum.", price: "74" },
        ],
      },
    ],
  },
  {
    id: "beverages",
    label: "Beverages",
    tagline: "Highland tea, cold pours, spirit-forward.",
    sections: [
      {
        id: "ceylon-tea",
        title: "Ceylon Tea",
        subtitle: "Single-estate, brewed at the table.",
        items: [
          { name: "Nuwara Eliya Silver Tips", desc: "Rare white tea, delicate, floral — brewed at 75°C.", price: "48" },
          { name: "Uva Highlands Black", desc: "Full-leaf black, hint of eucalyptus, honey finish.", price: "38" },
          { name: "Kandy Orange Pekoe", desc: "Bright, brisk, classic afternoon Ceylon.", price: "32" },
          { name: "Cardamom Chai", desc: "Kandyan spice blend, whole milk, palm sugar.", price: "42" },
        ],
      },
      {
        id: "coffee",
        title: "Coffee",
        subtitle: "Sourced from Java, brewed the Sri Lankan way.",
        items: [
          { name: "Ceylon Kopi", desc: "Traditional pot-brewed coffee, jaggery on the side.", price: "38" },
          { name: "Espresso", desc: "Double shot, Java single origin.", price: "35" },
          { name: "Iced Cardamom Latte", desc: "Cold-brew espresso, cardamom, oat milk.", price: "52" },
        ],
      },
      {
        id: "soft",
        title: "Cold & Soft",
        subtitle: "Island coolers and juice.",
        items: [
          { name: "Faluda", desc: "Rose syrup, basil seeds, vermicelli, vanilla ice cream.", price: "58" },
          { name: "Wood Apple Cooler", desc: "Wood apple pulp, lime, kithul, soda.", price: "45" },
          { name: "King Coconut", desc: "Whole young thambili — served chilled.", price: "38" },
          { name: "Kithul Lemonade", desc: "Fresh lime, palm treacle, mint, sparkling water.", price: "42" },
        ],
      },
      {
        id: "cocktails",
        title: "Cocktails & Arrack",
        subtitle: "Ceylon coconut arrack, the way it should be poured.",
        items: [
          { name: "Arrack Old Fashioned", desc: "Ceylon coconut arrack, palm sugar, orange bitters.", price: "125" },
          { name: "Nelum Sour", desc: "Arrack, lime, curry leaf, egg white, angostura.", price: "135" },
          { name: "Pandan Highball", desc: "Gin, pandan cordial, lime, soda.", price: "118" },
          { name: "Ceylon Negroni", desc: "Arrack, sweet vermouth, Campari, cinnamon.", price: "138" },
        ],
      },
      {
        id: "beer",
        title: "Beer",
        subtitle: "Cold — as it should be.",
        items: [
          { name: "Lion Lager (Sri Lanka)", desc: "Crisp Ceylon pilsner, 330ml.", price: "78" },
          { name: "Bintang", desc: "Indonesian pilsner, 330ml.", price: "62" },
          { name: "IPA · Rotating Local", desc: "Ask your server.", price: "95" },
        ],
      },
    ],
  },
  {
    id: "wine",
    label: "Wine",
    tagline: "Curated for spice — bright, low tannin, with soul.",
    sections: [
      {
        id: "sparkling",
        title: "Sparkling",
        subtitle: "By the glass · By the bottle.",
        items: [
          { name: "Prosecco Superiore DOCG", desc: "Valdobbiadene, Veneto · Italy. Pear, white flowers.", price: "125 / 680" },
          { name: "Blanc de Blancs", desc: "Domaine Alfred, California. Toasted brioche, citrus.", price: "168 / 895" },
          { name: "Rosé Champagne · Reserve", desc: "Champagne, France. Wild strawberry, chalk.", price: "— / 1,850" },
        ],
      },
      {
        id: "white",
        title: "White",
        subtitle: "Aromatic, off-dry, and mineral — friends of spice.",
        items: [
          { name: "Riesling · Trocken", desc: "Mosel, Germany. Green apple, slate, saline.", price: "115 / 640" },
          { name: "Gewürztraminer", desc: "Alsace, France. Lychee, rose, ginger.", price: "128 / 720" },
          { name: "Grüner Veltliner", desc: "Kamptal, Austria. White pepper, lime, herb.", price: "108 / 595" },
          { name: "Albariño", desc: "Rías Baixas, Spain. Sea spray, stone fruit.", price: "118 / 665" },
          { name: "Chardonnay · Unoaked", desc: "Margaret River, Australia. Nectarine, wet stone.", price: "125 / 695" },
        ],
      },
      {
        id: "rose",
        title: "Rosé",
        subtitle: "Pale, dry, endlessly food-friendly.",
        items: [
          { name: "Provence Rosé", desc: "Côtes de Provence, France. Watermelon, white peach.", price: "115 / 620" },
          { name: "Sangiovese Rosato", desc: "Tuscany, Italy. Wild raspberry, herbs.", price: "108 / 580" },
        ],
      },
      {
        id: "red",
        title: "Red",
        subtitle: "Low-tannin, bright, spice-forward reds.",
        items: [
          { name: "Pinot Noir", desc: "Willamette Valley, Oregon. Cherry, forest floor.", price: "148 / 820" },
          { name: "Gamay · Beaujolais-Villages", desc: "Beaujolais, France. Cranberry, violet.", price: "118 / 640" },
          { name: "Grenache Blend", desc: "Côtes du Rhône, France. Red plum, garrigue.", price: "112 / 615" },
          { name: "Nebbiolo", desc: "Langhe, Piedmont · Italy. Rose, tar, sour cherry.", price: "155 / 875" },
          { name: "Malbec · High Altitude", desc: "Uco Valley, Argentina. Blackberry, cocoa.", price: "128 / 720" },
        ],
      },
      {
        id: "dessert-wine",
        title: "Dessert & Fortified",
        subtitle: "For the end of the story.",
        items: [
          { name: "Tokaji Aszú 5 Puttonyos", desc: "Tokaj, Hungary · 100ml. Apricot, honey, saffron.", price: "165" },
          { name: "Sauternes", desc: "Bordeaux, France · 100ml. Peach, marmalade, botrytis.", price: "148" },
          { name: "Tawny Port · 20yr", desc: "Douro, Portugal · 60ml. Fig, walnut, caramel.", price: "138" },
        ],
      },
    ],
  },
];

// Backwards-compat flat menu for any other consumer
export const MENU = MENU_GROUPS.flatMap((g) => g.sections);
